import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { Table } from 'primeng/table';
import { BackendService } from '../../core/backend.service';
import { CONFIG } from '../../core/config';
import { InspectionReportHistory } from '../../viewmodels/reports/inspection-report-history';
import { ThicknessInspectionReportType } from '../../viewmodels/reports/thickness-reports/thickness-report';
import { DateTimeFormatterPipe } from '../pipes/date-time-formatter.pipe';
import { ThicknessReportTypePipe } from '../pipes/thickness-report-type.pipe';

@Component({
  selector: 'hb-inspection-history',
  templateUrl: './inspection-history.component.html',
  styleUrls: ['./inspection-history.component.scss'],
})
export class InspectionHistoryDialogComponent implements AfterViewInit {
  private _orgTreeNodeName: string;

  reports: InspectionReportHistory[] = [];
  filteredReportCount: number;

  public cols = [
    {
      field: 'description',
      header: this.i18NextPipe.transform('InspectionHistory.ReportType'),
      filterMatchMode: 'contains',
    },
    {
      field: 'discriminator',
      header: this.i18NextPipe.transform('InspectionHistory.InspectionType'),
      filterMatchMode: 'contains',
    },
    {
      field: 'inspectionDate',
      header: this.i18NextPipe.transform('InspectionHistory.Date'),
      filterMatchMode: 'date',
    },
    {
      field: 'inspectionConfidence',
      header: this.i18NextPipe.transform('InspectionHistory.Confidence'),
      filterMatchMode: 'contains',
    },
  ];

  @ViewChild('inspectionTable', { static: true }) public tableRef: Table;

  public get orgTreeNodeName(): string {
    return this._orgTreeNodeName;
  }

  public set orgTreeNodeName(name: string) {
    this._orgTreeNodeName = name;
  }

  public set orgTreeNodeId(id: string) {
    if (!id) {
      this.reports = [];
    } else {
      this.backendService
        .getAllById<InspectionReportHistory>(InspectionReportHistory, id, CONFIG.apiRoutes.inspectionReportHistory)
        .subscribe(reports => {
          if (reports) {
            this.reports = reports;
          }
        });
    }

  }

  constructor(
    private backendService: BackendService,
    private dateFormatter: DateTimeFormatterPipe,
    private thicknessReportTypePipe: ThicknessReportTypePipe,
    private i18NextPipe: I18NextPipe
  ) { }

  public ngAfterViewInit(): void {
    // Add custom filter for date column
    if (this.tableRef) {
      // :TODO
      // const customFilterConstraints = this.tableRef.filterConstraints;

      // if (customFilterConstraints) {
      //   customFilterConstraints['date'] = (value: any, filter: any) => {
      //     const dateString = this.dateFormatter.transform(value);

      //     return dateString.includes(filter);
      //   };

      //   this.tableRef.filterConstraints = customFilterConstraints;
      // }
    }
  }

  dateFilter(value: any, filter: any): boolean {
    const dateString = this.dateFormatter.transform(value);

    return dateString.includes(filter);
  }

  getDescription(report: InspectionReportHistory, value: string) {
    return report.discriminator !== 'InspectionReport' ? this.thicknessReportTypePipe.transform(ThicknessInspectionReportType[value]) : value;
  }

  getDiscriminator(value: string): string {
    switch (value) {
      case 'InspectionReport':
        return this.i18NextPipe.transform('InspectionHistory.InspectionReport');

      case 'ThicknessReport':

      case 'ThicknessReportUt':

      case 'ThicknessReportRt':
        return this.i18NextPipe.transform('InspectionHistory.ThicknessReport');

      default:
        break;
    }
  }
}
